import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const PrivacyPolicy = () => {
  return (
    <Container className="my-5">
      <Row className="justify-content-center">
        <Col xs={12}>
          <h3 className="text-center mb-4">Privacy Policy</h3>
          <p>
            Welcome to <strong>The Challenge Of Everest Board Game</strong>.
            This Privacy Policy outlines how we collect, use, and protect your
            personal information when you use our website. By accessing or
            using our website, you consent to the terms outlined in this Privacy
            Policy.
          </p>

          <h5>1. Information We Collect</h5>
          <p>
            We may collect personal information such as your name, email
            address, and phone number when you interact with our website,
            subscribe to our newsletter, or fill out a contact form.
            Additionally, we may collect non-personal information such as IP
            addresses and browsing behaviour for analytics purposes.
          </p>

          <h5>2. Use of Information</h5>
          <p>
            We use the information we collect to communicate with you, provide
            you with information or services you request, and improve our
            website's content and functionality. We may also use your
            information for marketing purposes, such as sending you promotional
            emails or newsletters. You have the option to opt out of receiving
            marketing communications from us.
          </p>

          <h5>3. Data Security</h5>
          <p>
            We are committed to protecting your personal information and have
            implemented appropriate security measures to safeguard your data
            against unauthorized access or disclosure. However, please be aware
            that no method of transmission over the internet or electronic
            storage is 100% secure, and we cannot guarantee absolute security of
            your information.
          </p>

          <h5>4. Third-Party Disclosure</h5>
          <p>
            We do not sell, trade, or otherwise transfer your personal
            information to third parties without your consent, except as
            required by law or as necessary to fulfill our obligations to you.
            However, we may share your information with trusted third-party
            service providers who assist us in operating our website, conducting
            our business, or servicing you.
          </p>

          <h5>5. Cookies</h5>
          <p>
            Our website may use cookies to enhance your browsing experience and
            track usage patterns. You can choose to disable cookies in your
            browser settings, but this may affect the functionality of our
            website. By continuing to use our website without changing your
            cookie settings, you consent to our use of cookies.
          </p>

          <h5>6. Links to Third-Party Websites</h5>
          <p>
            Our website may contain links to third-party websites. We are not
            responsible for the privacy practices or content of these websites.
            We encourage you to review the privacy policies of these websites
            before providing any personal information.
          </p>

          <h5>7. Children's Privacy</h5>
          <p>
            Our website is not directed to individuals under the age of 13. We
            do not knowingly collect personal information from children under 13
            years of age. If you are a parent or guardian and believe that your
            child has provided us with personal information, please contact us
            immediately so that we can remove such information from our records.
          </p>

          <h5>8. Changes to Privacy Policy</h5>
          <p>
            We reserve the right to modify or update this Privacy Policy at any
            time. Any changes will be effective immediately upon posting on this
            page. We encourage you to review this Privacy Policy periodically
            for changes.
          </p>

          <h5>9. Contact Us</h5>
          <p>
            If you have any questions or concerns about our Privacy Policy, or
            if you would like to exercise your rights regarding your personal
            information, please contact us at{" "}
            <a href="mailto:thechallengeofeverestgame@gmail.com">
              thechallengeofeverestgame@gmail.com
            </a>
            .
          </p>

          <p>
            By using our website, you acknowledge that you have read and
            understood this Privacy Policy and agree to the collection and use
            of your personal information as described herein.
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default PrivacyPolicy;
